class QuantityInputs {
	constructor(el) {
		this.el = el;
		this.attachHandlers();
	}

	attachHandlers = () => {
		// Prevent default so it doesn't auto collapse the parent section
		this.el.addEventListener('click', event => {
			event.preventDefault();
		});
	};
}

const quantityInputs = Array.from(
	document.querySelectorAll('.cc-quantity-input')
);
quantityInputs.forEach(el => {
	new QuantityInputs(el);
});
